import { render, staticRenderFns } from "./FloatingBallGroup.vue?vue&type=template&id=a0d61ad8&scoped=true"
import script from "./FloatingBallGroup.vue?vue&type=script&lang=js"
export * from "./FloatingBallGroup.vue?vue&type=script&lang=js"
import style0 from "./FloatingBallGroup.vue?vue&type=style&index=0&id=a0d61ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d61ad8",
  null
  
)

export default component.exports